"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStaffMemberValidationSchema = makeStaffMemberValidationSchema;
const Yup = __importStar(require("yup"));
const accountFieldsValidation_1 = require("../../../Persons/accountFieldsValidation");
/**
 * Backend przyjmuje flagi WYŁĄCZNIE jako wartości logiczne - odrzuca "true", 1 i "1".
 * Te pola sterują dostępem do faktur kosztowych i wyciągów bankowych, więc niejawna
 * konwersja typu jest tu niepożądana. Yup wymusza tu boolean po stronie klienta.
 */
const flagFields = {
    systemRoleId: Yup.number()
        .required("Wybierz rolę")
        .transform((value, original) => (original === "" || original === null ? undefined : value)),
    isDriver: Yup.boolean().required(),
    isInScrum: Yup.boolean().required(),
    hasCostInvoiceAccess: Yup.boolean().required(),
    hasBankAccess: Yup.boolean().required(),
    canLogSiteVisits: Yup.boolean().required(),
    canManageSbAccess: Yup.boolean().required(),
    isActive: Yup.boolean().required(),
};
function makeStaffMemberValidationSchema(isEditing) {
    return Yup.object().shape({
        ...flagFields,
        // E-mail systemowy, FIDman i projekty - te same reguły co na ekranie użytkowników,
        // bo konto zapisuje ta sama trasa v2 i serwer odrzuca te same przypadki.
        ...accountFieldsValidation_1.accountFields,
    });
}
